import './Footer.css';

function Footer() {
  return (
    <footer className='footer-container d-flex justify-content-center p-1 mt-3'>
      <p className='fonte-pequena m-0'>Núcleo Técnico de Monitoramento de Contratos de Gestão com a Riosaúde</p>
    </footer>
  );
}

export default Footer;
